export class EmployeesModel {
    public iEmployeesId?: number;
    public vIdempleado?: string;
    public vApellidoPaterno?: string;
    public vApellidoMaterno?: string;
    public vNombre?: string;
    public vNombreEmpleado?: string;
    public iEmployeeJobId?: number;
    public vEstado?: string;
    public vSucursal?: string;
    public vGenero?: string;
    public iEdad?: number;
    public vDepartamento?: string;
    public iActivo?: boolean;
    public dFechaInicio?: string;
    public dFechaFin?: string;
}
